module.exports = __webpack_public_path__ + "media/images/home/logo2-5251dd8e82cae5256e23c90f8e2fa83b.png";